import { AccessNotGranted } from '@healthhub/react-ui';
import { memo } from 'react';

import { ImmunisationEmpty } from '@shared/assets';
import { ERROR_CODES } from '@shared/constants/errorCodes';
import { NO_INTERNET_ERROR_MESSAGE, TRY_AGAIN_ERROR_MESSAGE } from '@shared/services/errorMessage';
import { checkIfAllErrored } from '@shared/utils/api/handlers/checkErrored/checkErrored';

import { EmptyStateScreen } from '../EmptyStateScreen';
import { NehrOptOut } from '../NehrOptOut';
import { NoInternetScreen } from '../NoInternetScreen';
import { RetrieveDataErrorDisplay } from '../RetrieveDataErrorDisplay';

interface Props {
  emptyImg?: string;
  emptyStateErrorMessage?: string;
  emptyStateErrorTitle?: string;
  errorCode?: null | string;
  errorMessage?: null | string;
  faqURL?: string;
  isCovidPage?: boolean;
  isEmpty?: boolean;
  IsNehrAccessHistory?: boolean;
  IsNehrOptOut?: boolean;
  isOffLine?: boolean;
  onRefreshError?: () => void;
  pageName: string;
  stack?: string;
}

const ErrorsScreen = ({
  emptyImg = ImmunisationEmpty,
  emptyStateErrorMessage,
  emptyStateErrorTitle,
  errorCode,
  errorMessage,
  faqURL,
  isCovidPage,
  isEmpty = false,
  IsNehrAccessHistory = false,
  IsNehrOptOut = false,
  isOffLine = false,
  onRefreshError,
  pageName,
  stack,
}: Props) => {
  if (isOffLine)
    return <NoInternetScreen buttonName="Refresh" errorMsg={NO_INTERNET_ERROR_MESSAGE} onRetry={onRefreshError} />;

  if (IsNehrOptOut && !IsNehrAccessHistory) return <NehrOptOut />;

  if (errorCode === ERROR_CODES.ACCESS_NOT_GRANTED_CODE)
    return <AccessNotGranted faqURL={faqURL ?? ''} pageName={pageName || ''} title="No Access Granted" />;

  if (checkIfAllErrored(errorMessage))
    return (
      <RetrieveDataErrorDisplay
        errorCode={errorCode || ''}
        errorMsg={TRY_AGAIN_ERROR_MESSAGE}
        onRefresh={onRefreshError}
        stack={stack}
      />
    );

  if (isEmpty) {
    return (
      <EmptyStateScreen
        emptyImg={emptyImg}
        errorMessage={emptyStateErrorMessage}
        errorTitle={emptyStateErrorTitle}
        isCovidPage={isCovidPage}
        namePage={pageName}
      />
    );
  }

  return null;
};

export default memo(ErrorsScreen);
